export default {
    orders: {
        orderCollections: [],
        create: {
            newOrder: {
                availableBrokerAgents: [],
                availableProducts: [],
                availableContactPersons: [],
                availablePrivateObjectTypes: [],
                availableCommercialObjectTypes: [],
                availablePrivateInvoiceReceiverTypes: [],
                availableCommercialInvoiceReceiverTypes: [],
                availableBillingMethods: [],
                pendingOrder: {}
            }
        },
        plan: {
            planOrder: {}
        },
        photoOrders: {},
        filmOrders: {},
        advanceList: {
            filters: {},
            result: {
                orders: []
            }
        },
        filters: {
            agentBrokerFilters: {
                orderType: null,
                search: "",
                brokerAgent: null,
                showArchived: false,
                orderPlacedAtStart: null,
                orderPlacedAtEnd: null
            }
        },
        orderCommandForBooking: null,
        brokerAgents: [],
        list: []
    }
};
